import { render, staticRenderFns } from "./BranchShowData.vue?vue&type=template&id=65b05f00"
import script from "./BranchShowData.vue?vue&type=script&lang=js"
export * from "./BranchShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports